import { createContext } from '@chakra-ui/react-utils';
import { type SystemStyleObject } from '@chakra-ui/react-v2';

import type { SegmentControlPart } from './types';

export type SegmentControlStyles = Partial<
  Record<SegmentControlPart, SystemStyleObject>
>;

const [SegmentControlStylesProvider, useSegmentControlStyles] =
  createContext<SegmentControlStyles>({
    name: 'SegmentControlStylesContext',
    errorMessage:
      'useSegmentControlStyles: `context` is undefined. Seems you used a SegmentControl sub-component that required a styles context outside of a SegmentControl component.',
  });

export { SegmentControlStylesProvider, useSegmentControlStyles };
